import { getParentElementByTagName } from '@skippay/core/utils/domUtils';

export const getELabFromClick = (element) => {
	const control =
		getParentElementByTagName(element, `BUTTON`, 4) || getParentElementByTagName(element, `A`, 4);
	return (
		(control &&
			(control.textContent || control.title || (element.tagName === `IMG` && element.alt))) ||
		``
	);
};
